import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { transparentize } from 'polished'
import { media } from '../theme'
import BorderDottedImage from '../assets/images/border--dotted.svg'
import TipIndicatorActiveImage from '../assets/images/tip-indicator--active.svg'
import TipIndicatorInactiveImage from '../assets/images/tip-indicator--inactive.svg'
import AssetShakaNoBgUrl from '../assets/images/shaka-no-bg.svg'
import Heading from '../components/Heading'

const themeColors = {
  red: {
    container: ['#32557c', '#791326'],
    tipIndicators: ['#d06986', '#c9505a'],
  },
  green: {
    container: ['#0e6e61', '#012a35'],
    tipIndicators: ['#85b779', '#23a298'],
  },
  greenBrown: {
    container: ['#0a3c3a', '#592616'],
    tipIndicators: ['#1d978f', '#359279'],
  },
}

const Container = styled.div`
  align-items: center;
  background: linear-gradient(
    to right,
    ${(p) => transparentize(0.15, themeColors[p.colorScheme].container[0])},
    ${(p) => transparentize(0.05, themeColors[p.colorScheme].container[1])}
  );
  display: flex;
  height: ${(p) => p.theme.spacing(3.25)};
  justify-content: space-between;
  padding: ${(p) => p.theme.spacing(-1)};
  position: relative;

  ${media.greaterThan('medium')`
    height: ${(p) => p.theme.spacing(4)};
    padding: ${(p) => p.theme.spacing(0)};
  `};
`

const TipIndicators = styled.div`
  align-items: center;
  display: flex;
  justify-contnet: center;
`

const TipIndicatorsHeading = styled.h3`
  border: 0 solid #fff;
  border-bottom-width: 0.15em;
  border-image: url(${BorderDottedImage}) 7 repeat;
  border-top-width: 0.15em;
  color: #ffd98f;
  font-size: ${(p) => p.theme.fontSize(0.75)};
  line-height: 70%;
  margin-right: ${(p) => p.theme.spacing(-2)};
  padding: 0.15em 0;
  text-transform: uppercase;

  ${media.greaterThan('medium')`
    border-bottom-width: 0.125em;
    border-image-slice: 6;
    border-top-width: 0.125em;
    font-size: ${(p) => p.theme.fontSize(2)};
    margin-right: ${(p) => p.theme.spacing(0.5)};
    padding: 0.25em 0;
  `};
`

const TipIndicator = styled.img.attrs({
  src: (p) => (p.active ? TipIndicatorActiveImage : TipIndicatorInactiveImage),
})`
  display: block;
  height: ${(p) => p.theme.fontSize(1)};
  margin-right: ${(p) => p.theme.spacing(-2)};

  &:last-child {
    margin-right: 0;
  }

  ${media.greaterThan('medium')`
    height: ${(p) => p.theme.fontSize(2)};
    margin-right: ${(p) => p.theme.spacing(0)};
  `};
`

const ShakaIndicator = styled.div`
  display: flex;
  align-items: center;
`

const ShakaImgContainer = styled.div`
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 50%;
  position: relative;
  background-color: #021f27;
  margin-right: -0.5rem;

  ${media.greaterThan('medium')`
    width: 2.75rem; 
    height: 2.75rem;
  `}
`

const ShakaImg = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 2.15rem;
  height: auto;

  ${media.greaterThan('medium')`
    width: 2.5rem; 
  `}
`

const ShakaCount = styled.div`
  color: #ffd98f;
  font-size: ${(p) => p.theme.fontSize(1.5)};
  padding: 0.15rem 1rem 0.15rem 1rem;
  background-color: #021f27;
  line-height: 1;
  border-radius: 0 8px 8px 0px;
`

const ShakaText = styled(Heading)`
  color: #ffd98f;
  display: none;
  margin-right: 0.75rem;

  ${media.greaterThan('medium')`
    display: block; 
  `}
`

const Shaka = () => (
  <ShakaImg
    src={AssetShakaNoBgUrl}
    alt=""
    loading="lazy"
    decoding="async"
    width={40}
    height={29}
  />
)

export default class TipTracker extends Component {
  static propTypes = {
    /** Name of room. **/
    roomName: PropTypes.string.isRequired,

    /** Number of opened tips. */
    openedTipsCount: PropTypes.number,

    /** Number of total tips. */
    tipsCount: PropTypes.number,

    /** Tip tracker background*/
    colorScheme: PropTypes.string,

    /** Number of shakas earned. */
    shakasEarned: PropTypes.number,

    /** Is the player over 18. */
    isOver18: PropTypes.number,
  }

  static defaultProps = {
    openedTipsCount: 0,
    tipsCount: 0,
  }

  render() {
    const {
      tipsCount,
      openedTipsCount,
      colorScheme,
      shakasEarned,
      isOver18,
      ...props
    } = this.props

    return (
      <Container colorScheme={colorScheme} {...props}>
        <TipIndicators colorScheme={colorScheme}>
          <TipIndicatorsHeading>Tips</TipIndicatorsHeading>
          {Array(tipsCount)
            .fill()
            .map((_, i) => (
              <TipIndicator key={`ribbon-${i}`} active={i < openedTipsCount} />
            ))}
        </TipIndicators>

        <ShakaIndicator>
          {/* {isOver18 && (
            <ShakaText level={3} last>
              Earn 3 Shakas & Enter To Win
            </ShakaText>
          )} */}

          <ShakaImgContainer>
            <Shaka />
          </ShakaImgContainer>

          <ShakaCount>{shakasEarned}</ShakaCount>
        </ShakaIndicator>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TipTracker.js